import React from 'react';
import { ActionButtonOutline, TaskNotes } from './TaskTable.styles';
import { TaskNote } from './types';
import { openModal } from 'modal-core-components';
import TaskNotesModal from './TaskNotesModal';

const showTaskNotesModal = taskNotes => {
  openModal(closeModal => <TaskNotesModal taskNotes={taskNotes} closeModal={closeModal} />);
};

const TaskNotesColumn = ({ taskNotes }: { taskNotes: TaskNote[] }) => {
  if (!taskNotes || taskNotes.length == 0) {
    return <TaskNotes> None </TaskNotes>;
  }

  return (
    <TaskNotes>
      <ActionButtonOutline aria-label="Notes count" onClick={() => showTaskNotesModal(taskNotes)}>
        {taskNotes.length} {taskNotes.length > 1 ? 'Notes' : 'Note'}
      </ActionButtonOutline>
    </TaskNotes>
  );
};

export default TaskNotesColumn;
